import { GradientedScroller, connected, withErrorBoundary, NoResults} from 'shared'
import { TopLevelPage, ModelGrid } from 'ui'
import SlideEventCard from 'ui/events/SlideEventCard'
import PeopleCard from 'ui/people/PeopleCard'
import { DateRangePicker } from 'react-date-range';
import { addDays, format} from 'date-fns';
import { useEffect, useState, useRef } from 'react';
import cable from 'channels/cable'

intervalId = null

GuestSecretCalenderView = ({match, history}) ->
  largeScreenId = match.params.id
  [slides, setSlides] = useState([])
  [sliderTime, setSliderTime] = useState("5000")
  [refreshTime, setRefreshTime] = useState(2000)
  [initialized, setInitialized] = useState(false)
  [userCounter, setUserCounter] = useState()
  [eventCounter, setEventCounter] = useState()
  [touchScreenId, settouchScreenId] = useState()
  [enabledTouch, setEnabledTouch] = useState(false)
  [notFound, setNotFound] = useState(false)
  [welcomeOverlayHidden, setWelcomeOverlayHidden] = useState(false)
  [currentSlideIndex, setCurrentSlideIndex] = useState(0)
  overlayTimerRef = useRef(null)
  subscriptionRef = useRef(null)

  loadSlideData = () =>
    setWelcomeOverlayHidden(false)
    Backend.get('/slides', {dsm_id: match.params.id, user_set_counter: userCounter, event_counter: eventCounter}).then (data) =>
      if data?.slides? and data.slides.length > 0
        setSlides(data.slides)
        setSliderTime(data.slider_time)
        setRefreshTime(if data.refresh_time then data.refresh_time else 3600000)
        setUserCounter(if data.user_set_counter then data.user_set_counter else 0)
        setEventCounter(data.event_counter)
        settouchScreenId(data.tsm_id)
        setEnabledTouch(data.enabled_touch)
        setNotFound(false)
      else
        setSlides([])
        setNotFound(true)
    .catch (err) ->
      console.error("Failed to load slides:", err)
      setSlides([])
      setNotFound(true)

  handleRedirect = () ->
    if enabledTouch
      history.push({
        pathname: "/touch-screen/" + touchScreenId,
        state: { from: history.location.pathname }
      })

  handleWelcomeClick = (slide) ->
    if not enabledTouch and slide.type is 'welcome'
      setWelcomeOverlayHidden(true)
      if overlayTimerRef.current
        clearTimeout(overlayTimerRef.current)

      # Restore overlay 5 seconds before slide time ends
      restoreTime = (slide.timer * 1000) - 1000
      if restoreTime > 0
        overlayTimerRef.current = setTimeout(() ->
          setWelcomeOverlayHidden(false)
        , restoreTime)


  useEffect(() ->
    dsmId = match.params.id
    console.log("Connecting to WelcomeCenterChannel for DSM:", dsmId)

    consumer = cable
    subscriptionRef.current = consumer.subscriptions.create(
      { channel: "WelcomeCenterChannel", dsm_id: dsmId },
      {
        connected: -> console.log("Cable connected"),
        disconnected: -> console.log("Cable disconnected"),
        received: (data) ->
          console.log("Received broadcast:", data)
          if data.action == "show_now" and data.selected_tsm_id
            history.push({
              pathname: "/touch-screen/" + data.selected_tsm_id,
              search: "?dsm_id=" + dsmId,
              state: { from: history.location.pathname }
            })
      }
    )

    return ->
      console.log("Unsubscribing from channel")
      subscriptionRef.current?.unsubscribe()
  , [match.params.id])

  useEffect(() ->
    console.log("Inside useEffect")

    unless initialized
      loadSlideData().then =>
        setInitialized true

    clearInterval(intervalId) if intervalId

    return ->
      clearInterval(intervalId)
      clearTimeout(overlayTimerRef.current) if overlayTimerRef.current
  , [initialized, refreshTime])

  useEffect(() ->
    if enabledTouch
      document.body.addEventListener("click", handleRedirect)
      document.body.addEventListener("touchstart", handleRedirect)
      return ->
        document.body.removeEventListener("click", handleRedirect)
        document.body.removeEventListener("touchstart", handleRedirect)
  , [touchScreenId, enabledTouch])

  <TopLevelPage className="Calendar" fullWidth={true} modelId={largeScreenId} base="/community-calendar">
    { if notFound
      <div className="text-center mt-10">
        <h2>No Large Screen Found</h2>
        <p>Please check the ID or contact support.</p>
      </div>
    else
      <div id="carouselExampleSlidesOnly" className="carousel slide" data-ride="carousel">
        <div className="carousel-inner">
          {if slides?
            slides.map((slide, index) => (
              <div key={index} className={if index == 0 then "carousel-item active" else "carousel-item"} data-interval={slide.timer*1000}>
                {if slide.type is 'image'
                  <div className="iframe-modal">
                    <img src={slide.data} style={{ width: '100%', height: '100vh' }}/>
                  </div>
                else if slide.type is 'web'
                  <div className="iframe-modal">
                    <iframe src={slide.file_path} width="100%" height="1080" scrolling="no" style={{  border: 'none', overflow: 'hidden' }} />
                  </div>
                else if slide.type is 'checkin'
                  <div className='container-fluid p-5 mx-5'>
                    <div className="row">
                      <div className="col">
                        <h1 className="section-heading-lowercase my-3 text-left">{slide.data.title}</h1>
                      </div>
                    </div>
                    {if slide.users.length == 0
                      <NoResults>We’re sorry, this section contains no checked in members.</NoResults>
                    else
                      <GradientedScroller containerClassName="feed-columns row">
                        {
                          slide.users.map((model) => (
                            <section className="feed-column col-sm-6 col-lg-4 col-xl-3" key={model.uid}>
                              <div className="feed-column-body">
                                <PeopleCard user={model} key={model.id} base='/large-screen' />
                              </div>
                            </section>
                          ))
                        }
                      </GradientedScroller>
                    }
                  </div>
                else if slide.type is 'welcome'
                  <div 
                    style={{
                      position: 'relative',
                      height: '100vh',
                      cursor: if not enabledTouch then 'pointer' else 'default'
                    }} 
                    onClick={(e) -> handleWelcomeClick(slide, e)}
                    onTouchStart={(e) -> handleWelcomeClick(slide, e)}
                  >
                    {
                      if enabledTouch
                        if slide.data.bg_file_path.endsWith('.mp4') or slide.data.bg_file_path.endsWith('.webm')
                          <video className="w-100 h-100 " src={slide.data.bg_file_path} autoPlay={true} loop={true} muted={true} controls={false} style={{ width: '100%', height: '100vh', objectFit: 'cover' }} />
                        else
                          <img className="w-100" src={slide.data.bg_file_path} style={{ width: '100%', height: '100vh' }} />
                      else
                        <div className="iframe-modal">
                          <iframe
                            src={slide.iframe_url}
                            width="100%"
                            scrolling="no"
                            style={{
                              border: 'none',
                              overflow: 'hidden',
                              height: '100vh',
                              pointerEvents: if welcomeOverlayHidden then 'auto' else 'none'
                            }}
                          />
                        </div>
                    }

                    { not welcomeOverlayHidden and (
                      <>
                        { slide.data.logo_file_path and
                          <img src={slide.data.logo_file_path} className="welcome-logo" />
                        }
                        <div className="welcome-text">
                          <h1 className="welcome-header" style={{ color: (if enabledTouch or slide.data.iframe == "" then '#FFFFFF' else '#000000') }}>{slide.data.header}</h1>
                          <h3 className="welcome-subheader" style={{ color: (if enabledTouch or slide.data.iframe == "" then '#FFFFFF' else '#000000') }}>{slide.data.subheader}</h3>
                        </div>
                      </>
                    )}
                  </div>

                else if slide.type is 'event'
                  <div className='container-fluid p-5 mx-5'>
                    {if slide.data.title?
                      <div className="row">
                        <div className="col">
                          <h1 className="section-heading-lowercase my-3 text-left ">{slide.data.title}</h1>
                        </div>
                      </div>
                    else
                      <div className="centered-title"></div>
                    }
                    {if (slide.data.events.length == 0)
                      <NoResults>We’re sorry, this section contains no events.</NoResults>
                    else
                      <GradientedScroller containerClassName="feed-columns row">
                      {
                        slide.data.events.map((model) => (
                          <section className="feed-column col-sm-6 col-lg-4 col-xl-3" key={model.uid}>
                            <div className="feed-column-body">
                              <SlideEventCard event={model} key={model.id} base='/large-screen' />
                            </div>
                          </section>
                        ))
                      }
                    </GradientedScroller>
                    }
                  </div>
                else
                  <div key="noSlides">No slides available</div>
                }
              </div>
            ))
          else
            <div key="noSlides">No slides available</div>
          }
        </div>
      </div>
    }
  </TopLevelPage>

export default withErrorBoundary connected GuestSecretCalenderView
